import { render, staticRenderFns } from "./leftNav.vue?vue&type=template&id=47e0b2f2&scoped=true"
import script from "./leftNav.vue?vue&type=script&lang=js"
export * from "./leftNav.vue?vue&type=script&lang=js"
import style0 from "./leftNav.vue?vue&type=style&index=0&id=47e0b2f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e0b2f2",
  null
  
)

export default component.exports